const renderTextWithLink = (text) => {
	const urlMatch = text?.match(/https?:\/\/[^\s)]+/);
	if (!urlMatch) return <>{text}</>;

	const url = urlMatch[0];
	const [before, after] = text.split(url);
	return (
		<>
			{before}
			<a
				href={url}
				target="_blank"
				rel="noopener noreferrer"
				className="yearEvent__link"
			>
				{url}
			</a>
			{after}
		</>
	);
};

export const YearEvent = ({
	year,
	info,
	infoSecond,
	infoThird,
	infoFourth,
	infoFifth,
}) => {
	return (
		<div className="yearEvent__component">
			<h2 className="yearEvent__title">{year}</h2>
			<p className="yearEvent__text">{renderTextWithLink(info)}</p>
			{infoSecond && (
				<p className="yearEvent__text event-margin">
					{renderTextWithLink(infoSecond)}
				</p>
			)}
			{infoThird && (
				<p className="yearEvent__text event-margin">
					{renderTextWithLink(infoThird)}
				</p>
			)}
			{infoFourth && (
				<p className="yearEvent__text event-margin">
					{renderTextWithLink(infoFourth)}
				</p>
			)}
			{infoFifth && (
				<p className="yearEvent__text event-margin">
					{renderTextWithLink(infoFifth)}
				</p>
			)}
		</div>
	);
};
